import * as React from 'react';

import { 
    makeLayout, makeLayoutSlot, 
    makePlugin, makePluginSlot,
    makeController, effectGetter, Effects,
    makeEntry, 
    IControllerContext, IPluginContext, ISlotContext, 
} from '../../../core/Slot';

import { GroupButton, Value } from '../types';

export type SelfValue = Value<string>;

export const emptyValue: SelfValue = { display: '', value: null };

export const URI = 'GroupButton';
export type URI = typeof URI;
declare module '../../../core/Slot' {
    interface URItoKind {
        [URI]: GroupButton<string>,
    }
}

const SlotContext = React.createContext({} as ISlotContext<URI>);
const ControllerContext = React.createContext({} as IControllerContext<URI>);
const EffectContext = React.createContext({} as Effects<URI>);
const PluginContext = React.createContext({} as IPluginContext<URI>);

export const Entry = makeEntry({
    SlotContext,
    ControllerContext,
    EffectContext,
    PluginContext,
    initSlots: {
        inner: {
            props: {
                children: () => null,
            },
            component: ({ children }) => {
                return (
                    <React.Fragment>{children}</React.Fragment>
                );
            },
        },
        item: {
            props: {
                value: () => -1,
                children: () => () => null,
                index: () => 0,
            },
            component: () => null,
        }
    },
    initControllers: {
        main: {
            name: 'empty',
            getData: () => [],
            getCurrentValue: () => null,
            changeValue: () => {},
            modifyValue: () => {},
            batch: () => {},
        },
        cursor: {
            get: () => 0,
            set: () => {},
            modify: () => {},
        },
    },
    initEffect: ['changeValue', 'cursorMove'],
});

export const Layout = makeLayout(SlotContext);
export const [useGetter, useSetter] = makeController(ControllerContext);
export const slot = makeLayoutSlot(SlotContext);
export const useEffect = effectGetter(EffectContext);
export const Plugin = makePlugin(PluginContext);
export const plugin = makePluginSlot({ PluginContext, SlotContext });
